import React from "react";
import "./loaderStyles.css";

const Loader = () => {
  return (
    <div className="lds-heart">
      <div></div>
    </div>
  );
};

export default Loader;
